import React from 'react';
import { Checkbox, Tooltip } from '@airbus/components-react';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import styles from './SaveColumnWidth.module.css';
import { t } from 'i18next';

type SaveColumnWidthToggleProps = {
  checked: boolean;
  onToggleChange: (checked: boolean) => void;
};

export const SaveColumnWidthToggle: React.FC<SaveColumnWidthToggleProps> = ({
  checked,
  onToggleChange,
}) => {
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onToggleChange(e.target.checked);
  };

  return (
    <div className='checkBoxMainDiv'>
      <div className={styles.checkBoxConfirmStylOuter}>
        <div>
          <label htmlFor='save-column-width-toggle' className={styles.checkBoxConfirmStyle}>
            <Checkbox
              id='save-column-width-toggle'
              checked={checked}
              onChange={handleCheckboxChange}
            />
            {t('view.store_column_width')}
            <div className={styles.storeColumnWidthTooltipContainer}>
              <Tooltip
                label={t('view.default_width_checkbox')}
                className={styles.storeColumnWidthTooltip}
              >
                <InfoOutlineIcon fontSize='small' />
              </Tooltip>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};
